/**
 * Obstetric Consultations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import prenatal from "./prenatal";
import {store} from "../../store";

// States
const state = {
    obstetricConsultations: [],
    obstetricConsultation: {}
};

// Getters
const getters = {
    obstetricConsultations: state => {
        return state.obstetricConsultations
    },

    obstetricConsultation: state => {
        return state.obstetricConsultation
    }
};

// Actions
const actions = {
    getObstetricConsultations(context, payload) {
        function successCallback(response) {
            context.commit('getObstetricConsultationsHandler', { obstetricConsultations: response.data.consultationsObstetrique });
        }

        function errorCallback(error) {

            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Obstetric.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getObstetricConsultation(context, payload) {
        function successCallback(response) {
            context.commit('getPrenatalConsultationsHandler',{prenatalConsultations:response.data.consultationObstetrique.consultation_prenatales});
            context.commit('getObstetricConsultationHandler', { obstetricConsultation: response.data.consultationObstetrique });
            context.commit('getMedicalFileHandler', { file: response.data.consultationObstetrique.dossier });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Obstetric.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createObstetricConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'consultation-obstetric', params: { consultation: response.data.consultationObstetrique.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Obstetric.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateObstetricConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'consultation-obstetric' });

            router.push({ name: 'consultation-obstetric', params: { consultation: response.data.consultationObstetrique.slug } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Obstetric.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteObstetricConsultation(context, payload) {
        function successCallback(response) {
            context.commit('deleteObstetricConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Obstetric.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archieveObstetricConsultation(context, payload) {
        function successCallback(response) {
            context.commit('archieveObstetricConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getPrenatalConsultationsHandler',{prenatalConsultations:response.data.resultat.consultation_prenatales});
            context.commit('getObstetricConsultationHandler', { obstetricConsultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Obstetric.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitObstetricConsultation(context, payload) {
        function successCallback(response) {
            context.commit('transmitObstetricConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getPrenatalConsultationsHandler',{prenatalConsultations:response.data.resultat.consultation_prenatales});
            context.commit('getObstetricConsultationHandler', { obstetricConsultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Obstetric.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    reactiveObstetricConsultation(context, payload) {
        function successCallback(response) {
            context.commit('reactiveMedecineConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getObstetricConsultationHandler', { obstetricConsultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.Obstetric.Reactive, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {

    reactiveMedecineConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-generals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    getObstetricConsultationsHandler(state, { obstetricConsultations }) {
        // Update obstetricConsultations state
        state.obstetricConsultations = obstetricConsultations;
    },

    getObstetricConsultationHandler(state, { obstetricConsultation }) {
        // Update obstetricConsultation state
        state.obstetricConsultation = obstetricConsultation;
    },

    deleteObstetricConsultationHandler(state, { index, successMessage }) {
        let i = state.obstetricConsultations.findIndex(obstetricConsultation => obstetricConsultation.slug === index);

        if (~i) {
            state.obstetricConsultations.splice(i, 1);

            router.push({ name: 'consultations-obstetrics' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    },

    archieveObstetricConsultationHandler(state, { index, successMessage }) {
            // router.push({ name: 'consultations-obstetrics' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitObstetricConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-obstetrics' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}